import React, {useState, useEffect} from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import Header from "../../header/Header";
import HeaderModulo from "../../header/HeaderModulo";
import Aside from "../../aside/Aside";
import { alerta, toast, formatDate } from '../../../services/utilities';
import { getComercios } from '../../../services/Usuario';
import { getReporteVentaDetallda } from '../../../services/Reportes';
import DetalleVenta from './DetalleVenta';
import { setIdTransaccion} from '../../../actions'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';

const LIMITE_INICIAL = 500;
const MAXIMO_DIAS_REPORTE = 4;

const agregarDias = (fecha, dias) => {
    const [anio, mes, dia] = fecha.split('-').map(Number);
    const fechaCalculada = new Date(anio, mes - 1, dia);
    fechaCalculada.setDate(fechaCalculada.getDate() + dias);
    return formatDate(fechaCalculada);
};

const calcularDiasDelRango = (fechaInicial, fechaFinal) => {
    const [anioInicial, mesInicial, diaInicial] = fechaInicial.split('-').map(Number);
    const [anioFinal, mesFinal, diaFinal] = fechaFinal.split('-').map(Number);
    const inicio = Date.UTC(anioInicial, mesInicial - 1, diaInicial);
    const fin = Date.UTC(anioFinal, mesFinal - 1, diaFinal);

    return Math.floor((fin - inicio) / 86400000) + 1;
};

function VentaDetallada(props){

    const tipoComercioInicial = props.data_sesion.rol_id === 1
        ? "PROMOTOR"
        : props.data_sesion.rol_id === 2 ? "VENDEDOR" : "";

    useEffect(() => {
        handleConsultarComercios();
    }, []);

    const tooltip1 = (<Tooltip id="tooltip">Venta Bruta</Tooltip>);
    const tooltip2 = (<Tooltip id="tooltip">Neto Vendedor</Tooltip>);
    const tooltip3 = (<Tooltip id="tooltip">Neto Promtor</Tooltip>);
    const tooltip4 = (<Tooltip id="tooltip">Neto Admin Externo</Tooltip>);
    const tooltip5 = (<Tooltip id="tooltip">Cobros Vendedor</Tooltip>);
    const tooltip6 = (<Tooltip id="tooltip">Cobros Promotor</Tooltip>);
    const tooltip7 = (<Tooltip id="tooltip">Cobros Admin Externo</Tooltip>);
    const tooltip8 = (<Tooltip id="tooltip">Neto Empresa</Tooltip>);

    const [spinerUsuarios, setSpinerUsuarios] = useState(true);
    const [spinerTabla, setSpinerTabla] = useState(false);
    const [verMnesaje, setVerMensaje] = useState(true);
    const [verTable, setVerTable] = useState(false);
    const [listsUsuarios, setListaUsuarios] = useState([]);
    const [listaVentas, setlistaVentas] = useState([]);
    const [resumen, setResumen] = useState({});
    const [filter, setFilter] = useState('');
    const [paginacion, setPaginacion] = useState({
        pagina: 1,
        limite: LIMITE_INICIAL,
        total: 0
    });

    const [filtro, setFiltro] = useState({
        "fecha_ini": formatDate(new Date()),
        "fecha_fin": formatDate(new Date()),
        "modalidad":"",
        "tipo_comercio": tipoComercioInicial,
        "usuario": "",
        "detalle": ""
    });

    const filterData = listsUsuarios.filter((item) => {
        const TipoComercioMatch = item.tipo.toLowerCase().includes(filter.toLowerCase());
        return TipoComercioMatch;
    });

    const textoFiltroDetalle = filtro.detalle.trim().toLowerCase();
    const ventasFiltradas = textoFiltroDetalle === ''
        ? listaVentas
        : listaVentas.filter((venta) => {
            const camposFiltrables = [
                venta.id_transaccion,
                venta.vendedor,
                venta.categoria,
                venta.valor,
                `${venta.nombre_cliente ?? ''} ${venta.detalle_venta ?? ''}`
            ];

            return camposFiltrables.some((campo) =>
                String(campo ?? '').toLowerCase().includes(textoFiltroDetalle)
            );
        });

    const handleInputFiltroChange = (event) => {
        const { name, value } = event.target;

        if((name === "fecha_ini" || name === "fecha_fin") && !value){
            return;
        }

        if(name === "tipo_comercio"){
            setFilter(value)
            setSelectedOptions([]);
            setFiltro((filtroActual) => ({ ...filtroActual, tipo_comercio: value, usuario: [] }));
            return;
        }

        if(name === "fecha_ini"){
            const fechaActual = formatDate(new Date());
            const fechaInicial = value > fechaActual ? fechaActual : value;
            const cuartoDia = agregarDias(fechaInicial, MAXIMO_DIAS_REPORTE - 1);
            const fechaFinMaxima = cuartoDia < fechaActual ? cuartoDia : fechaActual;

            setFiltro((filtroActual) => ({
                ...filtroActual,
                fecha_ini: fechaInicial,
                fecha_fin: filtroActual.fecha_fin < fechaInicial || filtroActual.fecha_fin > fechaFinMaxima
                    ? fechaFinMaxima
                    : filtroActual.fecha_fin
            }));
            return;
        }

        if(name === "fecha_fin"){
            const fechaActual = formatDate(new Date());
            const cuartoDia = agregarDias(filtro.fecha_ini, MAXIMO_DIAS_REPORTE - 1);
            const fechaFinMaxima = cuartoDia < fechaActual ? cuartoDia : fechaActual;
            const fechaFinal = value < filtro.fecha_ini
                ? filtro.fecha_ini
                : value > fechaFinMaxima ? fechaFinMaxima : value;

            setFiltro((filtroActual) => ({ ...filtroActual, fecha_fin: fechaFinal }));
            return;
        }

        setFiltro((filtroActual) => ({ ...filtroActual, [name]: value }));
    };

    const [selectedOptions, setSelectedOptions] = useState([]);

    const handleChangeMultiUsuario = (selected) => {
        setSelectedOptions(selected);
        handleInputFiltroChange({
            target: {
                name: 'usuario',
                value: selected ? selected.map(option => option.value) : []
            }
        });
    };

    const formatearMoneda = (value) =>{
        const valor = parseFloat(value);
        if (!isNaN(valor)) { 
          value = valor.toLocaleString('es-CO', {minimumFractionDigits: 0});
        }else{
            value = 0;
        }
        return value;
    }

    const handleConsultarComercios = async () => {
       
        try {
            await getComercios().then( response => {

                if(response.status !== undefined && response.status === 200){
                    setListaUsuarios(response.data.data);  
                }else{
                    toast('No tiene usuarios de este tipo o fallo la consulta','');
                }
            });

         }catch (error) {
            alerta('Error no controlado al cargar la infromación del select de usuarios (reportes/ventaDetallada/handleConsultarComercios) ->'+ error);
        }finally {
            setSpinerUsuarios(false);
        }
    }

    const obtenerDatosPaginacion = (data, pagina, limite, cantidadVentas) => {
        const metadata = data.paginacion ?? data.pagination ?? data.meta ?? {};
        const total = Number(
            metadata.total_registros ??
            metadata.total ??
            data.total_registros ??
            data.total ??
            cantidadVentas
        );

        return {
            pagina: Number(metadata.pagina_actual ?? metadata.pagina ?? metadata.current_page ?? pagina),
            limite: Number(metadata.limite ?? metadata.per_page ?? limite),
            total: Number.isFinite(total) ? total : cantidadVentas
        };
    };

    const handleBuscarVentas = async (pagina = 1, limite = paginacion.limite) => {
        const fechaActual = formatDate(new Date());

        if(!filtro.fecha_ini || !filtro.fecha_fin){
            alerta('Rango de fechas inválido','Debe seleccionar la fecha inicial y la fecha final.');
            return;
        }

        if(filtro.fecha_ini > fechaActual || filtro.fecha_fin > fechaActual){
            alerta('Rango de fechas inválido','No puede consultar fechas posteriores al día actual.');
            return;
        }

        const diasDelRango = calcularDiasDelRango(filtro.fecha_ini, filtro.fecha_fin);

        if(diasDelRango <= 0){
            alerta('Rango de fechas inválido','La fecha final no puede ser anterior a la fecha inicial.');
            return;
        }

        if(diasDelRango > MAXIMO_DIAS_REPORTE){
            alerta(
                'Rango de fechas inválido',
                `El reporte permite consultar máximo ${MAXIMO_DIAS_REPORTE} días. El rango seleccionado contiene ${diasDelRango} días.`
            );
            return;
        }

        if(filtro.tipo_comercio === "99"){
            toast('Seleccione un tipo de usuario','Tipo de usuario invalido');
            return;
        }

        setVerMensaje(false);
        setSpinerTabla(true);
        setVerTable(false);

        try {
            await getReporteVentaDetallda({
                fecha_ini: filtro.fecha_ini,
                fecha_fin: filtro.fecha_fin,
                modalidad: filtro.modalidad,
                tipo_comercio: filtro.tipo_comercio,
                id_comercio: filtro.usuario.length > 0 ? filtro.usuario : undefined,
                detalle: filtro.detalle,
                pagina,
                limite
            }).then( response => {

                if(response.status !== undefined && response.status === 200){
                    const ventas = Array.isArray(response.data.ventas) ? response.data.ventas : [];
                    setlistaVentas(ventas);
                    setResumen(response.data.resumen ?? {});
                    setPaginacion(obtenerDatosPaginacion(response.data, pagina, limite, ventas.length));

                    if(ventas.length > 0){
                        setVerTable(true);
                    }else{
                        setVerMensaje(true)
                        setVerTable(false);
                    }

                }else{
                    toast('Error al ejecutar la consulta','');
                }
            });

         }catch (error) {
            alerta('Error no controlado al cargar la infromación de ventas  (reportes/ventaDetallada/handleBuscarVentas) ->'+ error);
        }finally {
            setSpinerTabla(false);
        }
    }

    const handleTransaccionSeleccionada = (id_transaccion) => {
        props.setIdTransaccion(id_transaccion)
    }

    const handleCambioPagina = (event) => {
        handleBuscarVentas(event.page + 1, event.rows);
    };

    const transaccionBody = (venta) => <span className="badge text-bg-warning"># {venta.id_transaccion}</span>;
    const fechaBody = (venta) => <span>{venta.fecha}</span>;
    const horaBody = (venta) => <span>{venta.hora}</span>;
    const vendedorBody = (venta) => <b style={{fontSize : '10px'}}>{venta.id_comercio} - {venta.vendedor}</b>;
    const modalidadBody = (venta) => {
        const clase = venta.categoria === 'APUESTA' ? 'text-success' : venta.categoria === 'QUINTA' ? 'text-info' : 'text-primary';
        return <b className={clase}>{venta.categoria}</b>;
    };
    const valorBody = (venta) => `$ ${formatearMoneda(venta.valor)}`;
    const resumenBody = (venta) => <span style={{fontSize : '10px'}}>{venta.nombre_cliente} {venta.detalle_venta}</span>;
    const detalleBody = (venta) => (
        <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            data-bs-toggle="modal"
            data-bs-target="#modalDetalleVenta"
            onClick={() => handleTransaccionSeleccionada(venta.id_transaccion)}
        >
            detalle
        </button>
    );

    const skeletonRows = Array.from({ length: 8 }, (_, index) => ({ id: index }));
    const skeletonTextBody = () => <Skeleton width="100%" height="1.8rem"></Skeleton>;
    const skeletonActionBody = () => <Skeleton width="4rem" height="2rem"></Skeleton>;

    return(
        <React.Fragment>
            <Header></Header>
            <Aside></Aside>
            <main id="main" className="main">
                <HeaderModulo nombre_modulo={props.modulo}></HeaderModulo>
                <section className="section">
                    <div className='row'>
                        <div className='col-md-2 mb-3'>
                            <label className="mb-1">Desde:</label>
                            <div className="input-group">
                                <input 
                                    type="date" 
                                    className="form-control" 
                                    id="fecha_ini" 
                                    name="fecha_ini" 
                                    value={filtro.fecha_ini}
                                    max={formatDate(new Date())}
                                    onChange={handleInputFiltroChange} 
                                />
                            </div>
                        </div>
                        <div className='col-md-2 mb-3'>
                            <label className="mb-1">Hasta:</label>
                            <div className="input-group">
                                <input 
                                    type="date" 
                                    className="form-control" 
                                    id="fecha_fin" 
                                    name="fecha_fin" 
                                    value={filtro.fecha_fin}
                                    min={filtro.fecha_ini}
                                    max={agregarDias(filtro.fecha_ini, MAXIMO_DIAS_REPORTE - 1) < formatDate(new Date())
                                        ? agregarDias(filtro.fecha_ini, MAXIMO_DIAS_REPORTE - 1)
                                        : formatDate(new Date())}
                                    onChange={handleInputFiltroChange} 
                                />
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-2 mb-3'>
                            <label className="mb-1">Modalidad</label>
                            <div className='input-group'>
                                <select 
                                    className="form-select form-control"
                                    name="modalidad"
                                    value={filtro.modalidad}
                                    onChange={handleInputFiltroChange}
                                >
                                    <option value="">(TODAS)</option>
                                    <option value="1">APUESTA</option>
                                    <option value="2">QUINTA</option>
                                    <option value="3">ASTROS</option>
                                    <option value="4">BONO</option>
                                    <option value="5">RIFA</option>
                                    <option value="6">GANE MAS</option>
                                </select>
                            </div>
                        </div>
                        <div className='col-md-2 mb-3'>
                            <label className="mb-1">Tipos de Usuario</label>
                            <div className='input-group'>
                                <select 
                                    className="form-select form-control"
                                    name="tipo_comercio"
                                    value={filtro.tipo_comercio}
                                    onChange={handleInputFiltroChange}
                                >
                                    <option value="99">-Seleccione-</option>
                                    { props.data_sesion.rol_id === 0?
                                    <>
                                        <option value="">(TODOS)</option>
                                        <option value="ADMIN-EXTERNO">SOCIO EMPRESA</option>
                                        <option value="PROMOTOR">PROMOTOR</option>
                                        <option value="VENDEDOR">VENDEDOR</option>
                                    </>
                                    :''}
                                    { props.data_sesion.rol_id === 1?
                                    <>  
                                        <option value="PROMOTOR">PROMOTOR</option>
                                    </>
                                    :''}
                                    { props.data_sesion.rol_id === 2?
                                    <>
                                        <option value="VENDEDOR">VENDEDOR</option>
                                    </>
                                    :''}
                                </select>
                            </div>
                        </div>
                        {filtro.tipo_comercio !== '99' ?
                            <div className='col-md-3'>
                                <label className="mb-1">{filtro.tipo_comercio === 'PROMOTOR' ? 'Promotores' : filtro.tipo_comercio === 'ADMIN-EXTERNO' ? 'Administradores' : filtro.tipo_comercio === 'VENDEDOR' ? 'Vendedores' : 'Usuarios' }</label>
                                {spinerUsuarios ?
                                    <div className="d-flex">
                                        <div className="spinner-border" role="status"></div>                 
                                    </div>
                                :
                                    <div className='input-group'>
                                        <Select
                                            isMulti
                                            name="usuario"
                                            options={Array.isArray(filterData) ? filterData.map(usuario => ({
                                                value: usuario.id_comercio,
                                                label: `${usuario.id_comercio} - ${usuario.nombre} (${usuario.alias})`
                                            })) : []}
                                            value={selectedOptions}
                                            onChange={handleChangeMultiUsuario}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="(TODOS)"
                                            styles={{
                                                container: (provided) => ({
                                                    ...provided,
                                                    width: '100%'
                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    width: '100%'
                                                }),
                                                control: (provided) => ({
                                                    ...provided,
                                                    width: '100%'
                                                })
                                            }}
                                        />
                                    </div>
                                }
                            </div>
                        :''}
                        <div className='col-md-3 mb-3'>
                            <label className="mb-1">Detalles</label>
                            <div className="input-group">
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    id="detalle" 
                                    name="detalle" 
                                    value={filtro.detalle}
                                    placeholder="Transacción, vendedor, modalidad, valor o resumen"
                                    onChange={handleInputFiltroChange}
                                />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <label className="mb-1">&emsp;</label>
                            <div className="input-group">
                                <button 
                                    type="button" 
                                    className="btn btn-outline-primary btn-md"
                                    onClick={() => handleBuscarVentas(1, paginacion.limite)}
                                    disabled={spinerTabla}
                                >
                                    Buscar
                                </button>
                            </div>
                        </div>
                    </div>
                    {verTable ?
                        <>
                        <div className="row">
                            <div className='col-md-3 mt-1'>
                                <OverlayTrigger placement="top" overlay={tooltip1}>
                                    <div className="card-totales-venta">
                                        <h6 className="m-0"><b>V. Bruta</b></h6>
                                        <h6 className="text-secondary m-0"><b>$ {formatearMoneda(resumen.venta_bruta)}</b></h6>
                                    </div>
                                </OverlayTrigger>
                            </div>
                            <div className='col-md-3 mt-1'>
                                <OverlayTrigger placement="top" overlay={tooltip2}>
                                <div className="card-totales-venta">
                                    <h6 className="m-0"><b>N. Vendedor</b></h6>
                                    <h6 className="text-danger m-0"><b>$ {formatearMoneda(resumen.neto_vendedor)}</b></h6>
                                </div>
                                </OverlayTrigger>
                            </div>
                            <div className='col-md-3 mt-1'>
                                <OverlayTrigger placement="top" overlay={tooltip3}>
                                    <div className="card-totales-venta">
                                        <h6 className="m-0"><b>N. Promotor</b></h6>
                                        <h6 className="text-danger m-0"><b>$ {formatearMoneda(resumen.neto_promotor)}</b></h6>
                                    </div>
                                </OverlayTrigger>
                            </div>
                            <div className='col-md-3 mt-1'>
                                <OverlayTrigger placement="top" overlay={tooltip4}>
                                    <div className="card-totales-venta">
                                        <h6 className="m-0"><b>N. Adm Ext</b></h6>
                                        <h6 className="text-danger m-0"><b>$ {formatearMoneda(resumen.neto_admin_externo)}</b></h6>
                                    </div>
                                </OverlayTrigger>
                            </div>
                        </div>
                        <div className='row mb-2'>
                            <div className='col-md-3 mt-1'>
                                <OverlayTrigger placement="top" overlay={tooltip5}>
                                    <div className="card-totales-venta" title='Cobros Vendedores'>
                                        <h6 className="m-0"><b>C. Vendedor</b></h6>
                                        <h6 className="text-info m-0"><b>$ {formatearMoneda(resumen.cobro_vendedor)}</b></h6>
                                    </div>
                                </OverlayTrigger>
                            </div>
                            <div className='col-md-3 mt-1'>
                                <OverlayTrigger placement="top" overlay={tooltip6}>
                                    <div className="card-totales-venta">
                                        <h6 className="m-0"><b>C. Promotor</b></h6>
                                        <h6 className="text-info m-0"><b>$ {formatearMoneda(resumen.cobro_promotor)}</b></h6>
                                    </div>
                                </OverlayTrigger>
                            </div>
                            <div className='col-md-3 mt-1'>
                                <OverlayTrigger placement="top" overlay={tooltip7}>
                                    <div className="card-totales-venta">
                                        <h6 className="m-0"><b>C. Adm Ext</b></h6>
                                        <h6 className="text-info m-0"><b>$ {formatearMoneda(resumen.cobro_admin_externo)}</b></h6>
                                    </div>
                                </OverlayTrigger>
                            </div>
                            <div className='col-md-3 mt-1'>
                                <OverlayTrigger placement="top" overlay={tooltip8}>
                                    <div className="card-totales-venta">
                                        <h6 className="m-0"><b>N. Empresa</b></h6>
                                        <h6 className="text-success m-0"><b>$ {formatearMoneda(resumen.neto_empresa + resumen.cobro_vendedor + resumen.cobro_promotor + resumen.cobro_admin_externo)}</b></h6>
                                    </div>
                                </OverlayTrigger>
                            </div>
                        </div>
                        </>
                    :''}
                    {verTable ?
                    <>     
                        <div className='d-flex justify-content-between align-items-center mb-1'>
                            <span className='text-secondary mx-4' style={{fontSize :'12px'}}>
                                Total registros: {paginacion.total}
                            </span>
                        </div>
                        <div className="card">
                            <div className="card-body">
                                <DataTable
                                    value={ventasFiltradas}
                                    dataKey="id_transaccion"
                                    size="small"
                                    rowHover
                                    style={{ fontSize: '11px' }}
                                    responsiveLayout="scroll"
                                    emptyMessage="No hay ventas para mostrar"
                                    lazy
                                    paginator
                                    first={(paginacion.pagina - 1) * paginacion.limite}
                                    rows={paginacion.limite}
                                    totalRecords={paginacion.total}
                                    rowsPerPageOptions={[100, 250, 500]}
                                    onPage={handleCambioPagina}
                                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
                                    currentPageReportTemplate="{first} a {last} de {totalRecords}"
                                >
                                    <Column header="Transacción" body={transaccionBody} className="text-center"></Column>
                                    <Column
                                        field="fecha"
                                        header="Fecha"
                                        body={fechaBody}
                                        className="text-center"
                                        style={{ whiteSpace: 'nowrap' }}
                                    ></Column>
                                    <Column field="hora" header="Hora" body={horaBody} className="text-center"></Column>
                                    <Column field="vendedor" header="Vendedor" body={vendedorBody} className="text-center"></Column>
                                    <Column field="categoria" header="Modalidad" body={modalidadBody} className="text-center"></Column>
                                    <Column field="valor" header="Valor" body={valorBody} className="text-center"></Column>
                                    <Column header="Resumen" body={resumenBody}></Column>
                                    <Column header={<><i className="bi bi-clipboard-heart"></i> Detalle</>} body={detalleBody} className="text-center"></Column>
                                </DataTable>
                            </div>
                        </div>
                    </>
                    :''}

                    {spinerTabla ?
                    <div className="card mt-3">
                        <div className="card-body">
                            <div className="row mb-3">
                                {Array.from({ length: 4 }, (_, index) => (
                                    <div className="col-md-3" key={index}>
                                        <Skeleton height="3rem"></Skeleton>
                                    </div>
                                ))}
                            </div>
                            <DataTable value={skeletonRows} size="small" responsiveLayout="scroll">
                                <Column header="Transacción" body={skeletonTextBody}></Column>
                                <Column header="Fecha" body={skeletonTextBody}></Column>
                                <Column header="Hora" body={skeletonTextBody}></Column>
                                <Column header="Vendedor" body={skeletonTextBody}></Column>
                                <Column header="Modalidad" body={skeletonTextBody}></Column>
                                <Column header="Valor" body={skeletonTextBody}></Column>
                                <Column header="Resumen" body={skeletonTextBody}></Column>
                                <Column header="Detalle" body={skeletonActionBody}></Column>
                            </DataTable>
                        </div>
                    </div>
                    :''}
                    {verMnesaje ?
                    <div className='text-center text-secondary my-4'>
                        <h3>Sin resultado de búsqueda para los filtros aplicados.</h3>
                        <p>Por favor elija una combinación de filtros diferente.</p>
                    </div>
                    :''}
                </section>
            </main>
            <DetalleVenta></DetalleVenta>
        </React.Fragment>
    )
}

const mapSateToProps = state => {
    return {
        data_sesion: state.data_sesion,
    }
}

const mapDispatchToProps  = {
    setIdTransaccion
};

export default connect(mapSateToProps, mapDispatchToProps)(VentaDetallada)
